import type { AdminWhatsappTemplateRow } from '../../../domain/superadmin/types';
import { AppIcon } from '../../../components/icons/AppIcon';
import { Button } from '../../../components/ui';
import Switch from '../../../components/ui/Switch';

interface WhatsappTemplateCardProps {
    template: AdminWhatsappTemplateRow;
    onPreview: (template: AdminWhatsappTemplateRow) => void;
    onTest: (template: AdminWhatsappTemplateRow) => void;
    onDeliveryChange: (active: boolean) => void;
    testDisabled?: boolean;
}

export function WhatsappTemplateCard({
    template,
    onPreview,
    onTest,
    onDeliveryChange,
    testDisabled = false,
}: WhatsappTemplateCardProps) {
    return (
        <article className="flex flex-col rounded-xl border border-subtle bg-card p-5">
            <header className="mb-3 flex items-start gap-3">
                <div
                    className="flex h-10 w-10 shrink-0 items-center justify-center rounded-lg bg-[var(--brand-50)] text-[var(--brand-500)]"
                    aria-hidden
                >
                    <AppIcon name="whatsapp" className="h-5 w-5" />
                </div>
                <div className="min-w-0 flex-1">
                    <h3 className="text-base font-semibold text-default">{template.name}</h3>
                    {template.description && (
                        <p className="mt-1 text-sm text-secondary">{template.description}</p>
                    )}
                </div>
            </header>

            <div className="mb-4 flex items-center gap-1.5">
                <AppIcon name="zap" className="h-3.5 w-3.5 shrink-0 text-[var(--brand-500)]" aria-hidden />
                <code className="truncate font-mono text-sm text-secondary">{template.key}</code>
            </div>

            <div className="mb-4">
                <Switch
                    checked={template.deliveryActive}
                    onChange={onDeliveryChange}
                    label="Ativo"
                    description="Disparo automático nos eventos da plataforma"
                />
            </div>

            <footer className="mt-auto flex flex-col gap-2 sm:flex-row">
                <Button
                    type="button"
                    variant="outline"
                    size="sm"
                    className="w-full sm:flex-1"
                    onClick={() => onPreview(template)}
                >
                    Visualizar
                </Button>
                <Button
                    type="button"
                    size="sm"
                    className="w-full sm:flex-1"
                    onClick={() => onTest(template)}
                    disabled={testDisabled}
                >
                    Testar
                </Button>
            </footer>
        </article>
    );
}
